import { setPageTitle } from '../../../utils/utilities'
import History from './History'
import IDMapper from './IDMapper'

const UserDump = () => {
  setPageTitle('Admin | User Dump')
  return (
    <div className="container mx-auto">
      <IDMapper />
      <History />
    </div>
  )
}

export default UserDump
